<template>
  <div v-if="subcategory && subcategory.nodes">
    <div class="negative-bottom-margin"></div>
    <download-overview :nodes="transformedNodes" :additional-class="'download-block_overview'" />
  </div>
  <div v-else class="ta-c">No data found for subcategory</div>
</template>

<script setup lang="ts">
  import DownloadOverview from '~/components/product/DownloadOverview.vue';

  definePageMeta({ middleware: ['check-token'] });

  const props = defineProps({
    subcategory: {
      type: Object,
      required: false
    }
  });

  const transformedNodes = computed(() => {
    if (!props.subcategory || !props.subcategory.nodes) {
      return [];
    }
    // create blank elements for collecting data
    let productsArr: any[] = [];
    let transformedArr: any[] = [];
    let productCard = {
      items: [] as any[],
      productBlockType: 'ProductCard'
    };
    let productOverview = {
      items: [] as any[],
      productBlockType: 'ProductOverview'
    };
    let productBlank = {
      external: { title: '' },
      items: [],
      id: null,
      productBlockType: ''
    };

    // adding ProductBlocks by their type to our blank elements
    for (let productBlock of props.subcategory.nodes) {
      if (productBlock.productBlockType == 'ProductOverview') {
        productOverview.items.push(productBlock);
      } else if (productBlock.productBlockType == 'ProductCard') {
        productCard.items.push(productBlock);
      } else {
        transformedArr.push(productBlock);
      }
    }

    // adding transformed blank elements to our real data
    const productCardsArr = productsArr.filter((productBlock) => productBlock.productBlockType == 'ProductCard');
    const productOverviewsArr = productsArr.filter((productBlock) => productBlock.productBlockType == 'ProductOverview');

    if (productCardsArr.length > 0) transformedArr = [...transformedArr, ...productCardsArr];
    if (productCard.items.length > 0) transformedArr.push(productCard);
    if (productOverviewsArr.length > 0) transformedArr = [...transformedArr, ...productOverviewsArr];
    if (productOverview.items.length > 0) transformedArr.push(productOverview);
    return transformedArr;
  });
</script>
